module.exports = __webpack_public_path__ + "img/img28.809ef71f.png";